"use strict";
export { Textarea, TextareaPropsProvider } from './textarea.js';
